import * as tslib_1 from "tslib";
import { CELSIUS, FAHRENHEIT, TEMPERATURE } from '../units';
import { BaseConverter } from './base-converter';
/**
 * Temperature unit converter class
 */
var TemperatureConverter = /** @class */ (function (_super) {
    tslib_1.__extends(TemperatureConverter, _super);
    function TemperatureConverter() {
        var _this = _super.call(this, TEMPERATURE) || this;
        _this._baseUnit = CELSIUS;
        _this._baseConversionFunctions.set(FAHRENHEIT, function (value) { return value * 9 / 5 + 32; });
        _this._reverseConversionFunctions.set(FAHRENHEIT, function (value) { return (value - 32) * 5 / 9; });
        _this._check();
        return _this;
    }
    return TemperatureConverter;
}(BaseConverter));
export { TemperatureConverter };
/**
 * Temperature unit converter singleton
 */
export var TEMPERATURE_CONVERTER = new TemperatureConverter();
